import sanitizeHtml from 'sanitize-html';

const HTML_TAG_PATTERN = /<\/?[a-z][\s\S]*>/i;
const SAFE_COLOR = /^(?:#[\da-f]{3,8}|rgba?\([\d\s,.%]+\)|[a-z]+)$/i;

const ALIGNMENT_CLASSES = [
  'ql-align-center',
  'ql-align-right',
  'ql-align-justify',
];

const INDENT_CLASSES = Array.from(
  { length: 9 },
  (_, index) => `ql-indent-${index + 1}`
);

function escapeText(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function convertPlainTextToHtml(content: string) {
  return content
    .split(/\r?\n\s*\r?\n/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)
    .map((paragraph) => `<p>${escapeText(paragraph).replace(/\r?\n/g, '<br>')}</p>`)
    .join('');
}

export function formatArticleContent(content: string) {
  const html = HTML_TAG_PATTERN.test(content)
    ? content
    : convertPlainTextToHtml(content);

  return sanitizeHtml(html, {
    allowedTags: [
      'p',
      'br',
      'strong',
      'b',
      'em',
      'i',
      'u',
      's',
      'blockquote',
      'pre',
      'code',
      'ol',
      'ul',
      'li',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'span',
      'a',
    ],
    allowedAttributes: {
      a: ['href', 'target', 'rel'],
      span: ['style'],
      li: ['class', 'data-list'],
      p: ['class'],
      h1: ['class'],
      h2: ['class'],
      h3: ['class'],
      h4: ['class'],
      h5: ['class'],
      h6: ['class'],
    },
    allowedClasses: {
      li: INDENT_CLASSES,
      p: ALIGNMENT_CLASSES,
      h1: ALIGNMENT_CLASSES,
      h2: ALIGNMENT_CLASSES,
      h3: ALIGNMENT_CLASSES,
      h4: ALIGNMENT_CLASSES,
      h5: ALIGNMENT_CLASSES,
      h6: ALIGNMENT_CLASSES,
    },
    allowedSchemes: ['http', 'https', 'mailto'],
    allowedSchemesAppliedToAttributes: ['href'],
    allowProtocolRelative: false,
    allowedStyles: {
      span: {
        color: [SAFE_COLOR],
      },
    },
    transformTags: {
      a: (_tagName, attributes) => ({
        tagName: 'a',
        attribs: {
          ...attributes,
          rel: 'noopener noreferrer',
        },
      }),
    },
  });
}
